import { render, staticRenderFns } from "./QbIntegrationRule.vue?vue&type=template&id=1f550cab&"
import script from "./QbIntegrationRule.vue?vue&type=script&lang=js&"
export * from "./QbIntegrationRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports